import axios from "axios";

const API = axios.create({
  baseURL: "https://tollygram.azurewebsites.net/",
  // baseURL: "http://localhost:5000",
});

export const uploadPost = (data) => API.post("/posts", data);
